<template>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        :offset="offset"
        finished-text="没有更多了"
        @load="loadMore"
      >
        <div v-for="(item, i) in dataList" :key="i">
          <div v-if="item.IsOut" class="zhuan-item-box">
            <div class="zhuan-item">
              <div class="left-user">
                <div class="bd">
                  <div class="u-name">{{ item.FmNickName }}</div>
                  <svg width="94" height="11.52" fill="#ababab">
                    <text
                      dominant-baseline="baseline"
                      font-size="10"
                      y="9.52"
                      style="line-height: 1; vertical-align: middle:"
                    >
                      {{ item.AddDatetime }}
                    </text>
                  </svg>
                </div>
                <img :src="item.FmHeadPic" alt="" class="u-avatar" />
              </div>
              <div class="mid-box">
                <div class="des">转入</div>
                <div class="arrow arrow-ru"></div>
                <div class="price">{{ item.Integral }}</div>
              </div>
              <div class="right-user">
                <img :src="item.tmHeadPic" alt="" class="u-avatar" />
                <div class="bd">
                  <div class="u-name">{{ item.TmNickName }}</div>
                  <svg width="94" height="11.52" fill="#ababab">
                    <text
                      dominant-baseline="baseline"
                      font-size="10"
                      y="9.52"
                      style="line-height: 1; vertical-align: middle:"
                    >
                      {{ item.AddDatetime }}
                    </text>
                  </svg>
                </div>
              </div>
            </div>
            <div class="beizhu">备注:{{ item.Remarks }}</div>
          </div>
          <div v-else class="zhuan-item-box">
            <div class="zhuan-item">
              <div class="left-user">
                <div class="bd">
                  <div class="u-name">{{ item.TmNickName }}</div>
                  <svg width="94" height="11.52" fill="#ababab">
                    <text
                      dominant-baseline="baseline"
                      font-size="10"
                      y="9.52"
                      style="line-height: 1; vertical-align: middle:"
                    >
                      {{ item.AddDatetime }}
                    </text>
                  </svg>
                </div>
                <img :src="item.TmHeadPic" alt="" class="u-avatar" />
              </div>
              <div class="mid-box">
                <div class="des">转入</div>
                <div class="arrow arrow-chu"></div>
                <div class="price">{{ item.Integral }}</div>
              </div>
              <div class="right-user">
                <img :src="item.FmHeadPic" alt="" class="u-avatar" />
                <div class="bd">
                  <div class="u-name">{{ item.FmNickName }}</div>
                  <svg width="94" height="11.52" fill="#ababab">
                    <text
                      dominant-baseline="baseline"
                      font-size="10"
                      y="9.52"
                      style="line-height: 1; vertical-align: middle:"
                    >
                      {{ item.AddDatetime }}
                    </text>
                  </svg>
                </div>
              </div>
            </div>
            <div class="beizhu">备注:{{ item.Remarks }}</div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </template>
  <script>
  import common from "../tools/common";
  
  export default {
    data() {
      return {
        options: {
          type: "TransactionDetailTurnCoinList",
          PageIndex: 1,
          isOut: this.readType
        },
        offset: 100,
        refreshing: false,
        loading: true,
        finished: false,
        dataList: []
      };
    },
    props: {
      readType: Number,
      beginTime: String,
      endTime: String
    },
    methods: {
      init() {
        this.getList();
      },
      onRefresh() {
        this.finished = false;
        this.loading = true;
        Object.assign(this.options, {
            PageIndex: 1
        });
        this.getList();
      },
      loadMore() {
        Object.assign(this.options, {
            PageIndex: this.options.PageIndex + 1
        });
        this.loading = true;
        this.getList();
      },
      getList() {
        var that = this;
        this.$store.dispatch(this.options).then(
          res => {
            that.loading = false;
            if (that.refreshing) {
              that.refreshing = false;
            }
            common.Response.callNotMsgResponse(res, function(result) {
              console.log(result);
              if (result.data.length <= 0) {
                that.finished = true;
              }
              if (that.options.PageIndex > 1) {
                if (result.data.length > 0) {
                  result.data.forEach(element => {
                    that.dataList.push(element);
                  });
                }
              } else {
                that.dataList = result.data;
              }
            });
          },
          error => {
            console.log(error);
          }
        );
      }
    },
    watch: {
      beginTime: function(curVal, oldval) {
        if (curVal != oldval) {
          Object.assign(this.options, {
            PageIndex: 1,
            BeginTime: this.beginTime,
            EndTime: this.endTime
          });
          this.getList();
        }
      },
      endTime: function(curVal, oldval) {
        if (curVal != oldval) {
          Object.assign(this.options, {
            PageIndex: 1,
            BeginTime: this.beginTime,
            EndTime: this.endTime
          });
          this.getList();
        }
      }
    },
    created() {
      this.init();
    }
  };
  </script>
  <style lang="less" scoped>
  .jifenDetailPage {
    padding-bottom: 10px;
  }
  .selectdate-box {
    margin: 10px;
    background: #fff;
    border-radius: 8px;
    padding: 15px 12px;
    display: flex;
    align-items: center;
    .lable-box {
      display: flex;
      align-items: center;
      .icon {
        width: 16px;
        height: 16px;
        object-fit: contain;
        margin-right: 10px;
      }
      .title {
        font-size: 16px;
        color: #333;
      }
    }
    .input-control {
      flex: 1;
      overflow: hidden;
      text-align: right;
      font-size: 14px;
      color: #333;
      margin-right: 8px;
    }
  }
  .tongji-section {
    margin: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .col {
      width: 49%;
      background: #fff;
      border-radius: 8px;
      padding: 15px 6px;
      height: 100px;
      .tongji-box {
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        width: 100%;
        height: 100%;
        .price-box {
          font-size: 12px;
          color: #2b2b2b;
          .price {
            font-size: 22px;
            font-weight: bold;
          }
        }
        .des {
          font-size: 14px;
          color: #7c7c7c;
        }
      }
    }
  }
  .jifen-box {
    margin: 10px;
    background: #fff;
    border-radius: 8px;
    padding: 15px 0;
  }
  //转赠item
  .zhuan-item-box {
    margin: 0 10px;
    border-bottom: 1px solid #dedede;
    padding: 14px 0;
    .zhuan-item {
      display: flex;
      align-items: center;
      & > .left-user {
        justify-content: flex-end;
        .bd {
          margin-right: 8px;
          text-align: right;
          overflow: hidden;
          flex: 1;
        }
      }
      & > .right-user {
        .bd {
          margin-left: 8px;
          overflow: hidden;
          flex: 1;
        }
      }
      .u-name {
        font-size: 13px;
        color: #000000;
      }
      .u-date {
        font-size: 12px;
        color: #ababab;
        white-space: nowrap;
      }
      .u-avatar {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        object-fit: cover;
      }
      & > .mid-box {
        width: 40px;
        text-align: center;
        margin: 0 10px;
        & > .des {
          font-size: 13px;
          color: #0a0a0a;
        }
        & > .arrow {
          height: 2px;
          background-color: #696969;
          width: 40px;
          display: block;
          margin-top: 2px;
          &.arrow-ru {
            &:after {
              border-color: #696969;
              border-style: solid;
              border-width: 2px 0 0 0;
              -webkit-transform: rotate(35deg);
              -ms-transform: rotate(35deg);
              transform: rotate(35deg);
              margin-top: -3px;
              width: 6px;
              height: 6px;
              display: block;
              float: right;
              content: "";
            }
          }
          &.arrow-chu {
            &:after {
              border-color: #696969;
              border-style: solid;
              border-width: 2px 0 0 0;
              -webkit-transform: rotate(-35deg);
              -ms-transform: rotate(-35deg);
              transform: rotate(-35deg);
              margin-top: -3px;
              width: 6px;
              height: 6px;
              display: block;
              float: left;
              content: "";
            }
          }
        }
        & > .price {
          font-size: 15px;
          color: #ea0000;
        }
      }
    }
    .beizhu {
      text-align: center;
      margin-top: 10px;
      font-size: 12px;
      color: #484848;
    }
  }
  .zhuan-item-box .zhuan-item > .left-user,
  .zhuan-item-box .zhuan-item > .right-user {
    flex: 1;
    overflow: hidden;
    display: flex;
    align-items: center;
  }
  </style>
  